import React, { useContext } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import HomeComponent from './pages/home/index';
import Documentation from './pages/docs/index';
import DocTopic from './pages/docs/docTopic';
import Header from "./header";
import Footer from './footer';
import { AppContext } from './context/appContext';
import { ThemeProvider } from "styled-components";
import { themes } from "./theme/themes"
import { GlobalStyles } from './theme/globalStyles';

const AppComponent = () => {
  const { CurrentTheme } = useContext(AppContext);

  return (
    <ThemeProvider theme={themes[CurrentTheme]}>
      <GlobalStyles />
      <BrowserRouter>
        <Header />
        <div style={{minHeight: '400px'}}>
        <Routes>
          <Route path="/" element={<HomeComponent />} />
          <Route path="/docs" element={<Documentation />}>
            <Route path=":topic" element={<DocTopic />} />
          </Route>      
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        </div>
        <Footer />

      </BrowserRouter>
    </ThemeProvider>
  );
}


export default AppComponent;

